/**
 * Copy for the phase-1 GoTu Promo fee row (GOTU-5659).
 *
 * TODO(GOTU-5659): PLACEHOLDER COPY — confirm the wording with design/product
 * before shipping. This is a fee line, so the string is user-visible on the
 * office's shift fee breakdown.
 *
 * Phase 1 renders automatic office/state discounts only and never shows a code,
 * so the label stands alone with no code suffix. Trailing punctuation is NOT
 * part of the constant — each call site adds the colon only where its
 * neighbouring rows use one.
 */
export const PROMO_ROW_LABEL = 'GoTu Promo';
